import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import {
    FormFieldComponentProps,
    OptInInputComponent,
} from '@sheerid/jslib';

import { optInValidationError } from '../../../validators/customFieldValidators';

const RuleOptInComponent = ({
    isErrored,
    isRequired,
    onChange,
    value,
    verificationService,
}: FormFieldComponentProps) => {

    React.useEffect(() => {
        optInValidationError(isRequired)
    }, []);

    return (
        <div className="sid-field sid-opt-in">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-rule-opt-in">
                <div className={`sid-field__label sid-rule-opt-in__label sid-l-space-btm-sm${isRequired ? ' sid-field__label--required' : ''}`}>
                    <FormattedHTMLMessage
                        id="step.personalInfo.ruleOptInLabel"
                        defaultMessage="Not Seeking Profit"
                    />
                </div>
            </label>
            <div className="sid-l-position">
                <label>
                    <OptInInputComponent
                        isErrored={isErrored}
                        onChange={onChange}
                        value={value}
                    />
                    <div className="sid-field__label sid-checkbox__label">
                            <FormattedHTMLMessage
                                id="ruleOptIn"
                                defaultMessage="I certify that project maintainers are not seeking to make profit from this project by, for example, selling services or higher tiers."
                            />
                    </div>
                { isErrored ?
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id={'errorId.invalidOptIn'}
                            defaultMessage="Must be selected to continue"
                        />
                    </div>
                    : null
                }
                </label>
            </div>
        </div>
    );
};

export {  RuleOptInComponent };
